import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  Actions,
  createEffect,
  ofType
} from "@ngrx/effects";
import {
  of
} from "rxjs";
import {
  catchError,
  exhaustMap,
  map,
} from "rxjs/operators";
import { IPartnerBranding } from "../../domain/partner-branding.model";
import { PartnerBrandingService } from "../../service/partner-branding.service";
import * as PartnerBrandingActions from "./partner-branding.action";
import { PartnerBrandingActionTypes } from "./partner-branding.action";

@Injectable()
export class PartnerBrandingEffect {

  /**
   * SAN-384/386 — only ever dispatched with a non-empty abbreviation (i.e. on a
   * spoke subdomain). SAN-387's backend route is shipped and normally returns
   * 200 (degrading gracefully to an org-logo-only body when the partner has no
   * white-label branding configured, per that route's own module spec) — the
   * fault branch is now the exceptional path (a genuinely unknown abbreviation,
   * or a transient failure), not the everyday one. It still degrades to the
   * tenant-wide branding rather than surfacing an error to the visitor.
   */
  getPartnerBranding$ = createEffect(() => this.actions$.pipe(
    ofType<PartnerBrandingActions.GetPartnerBranding>(PartnerBrandingActionTypes.GetPartnerBranding),
    exhaustMap((action) =>
      this.partnerBrandingService.getPartnerBranding(action.payload).pipe(
        map((data: IPartnerBranding) => new PartnerBrandingActions.GetPartnerBrandingSuccess(data)),
        catchError((err: HttpErrorResponse) => of(new PartnerBrandingActions.GetPartnerBrandingFault(err.message)))
      )
    )
  ));

  constructor(private actions$: Actions, private partnerBrandingService: PartnerBrandingService) {
  }
}
